import { RefCallback, useCallback, useRef, useState } from 'react';
import { getLayoutPanelFormColumns } from '../utils/layouts/getLayoutPanelFormColumns';

// Form column count for a SettingsPanel rendered outside the resizable editor
// panel (the generate-matrix dialog) — the same width breakpoints, measured on
// the host element instead of the panel width. 0 = not measured yet; the item
// CSS falls back to 12 for that first frame.
export const useLayoutFormColumns = (): {
  measureRef: RefCallback<HTMLElement>;
  columns: number;
} => {
  const [columns, setColumns] = useState(0);
  const observerRef = useRef<ResizeObserver | null>(null);

  const measureRef = useCallback<RefCallback<HTMLElement>>((element) => {
    observerRef.current?.disconnect();

    if (!element) {
      observerRef.current = null;
      return;
    }

    const applyWidth = (width: number): void => {
      if (width > 0) {
        setColumns(getLayoutPanelFormColumns(width));
      }
    };

    applyWidth(element.clientWidth);
    observerRef.current = new ResizeObserver(() =>
      applyWidth(element.clientWidth)
    );
    observerRef.current.observe(element);
  }, []);

  return { measureRef, columns };
};
